import { RouteObject } from 'react-router-dom';
import { AttendTrack } from '../AttendTrack';
import { InboxRoutes } from '../pages/Inbox/routes';
import { AgendaRoutes } from '../pages/Agendas/routes';
import { PreparePackageRoutes } from '../pages/PreparePackage/routes';
import { DashboardRoutes } from '../pages/Dashboard/routes/DashboardRoutes';

export const AttendTrackRoutes: RouteObject[] = [
  {
    path: '',
    element: <AttendTrack />,
  },
  ...InboxRoutes,
  ...AgendaRoutes,
  ...PreparePackageRoutes,
  ...DashboardRoutes,
];
